import {
  PENDIENTE_LOADING,
  PENDIENTE_SUCCESS,
  PENDIENTE_ERROR,
  POST_PENDIENTE_LOADING,
  POST_PENDIENTE_SUCCESS,
  POST_PENDIENTE_ERROR,
  CLEAR_PENDIENTE_DATA,
} from "../../constants/ActionTypes";

import pendienteInitialState from "../initialStates/pendienteInitialState";

const pendiente = (state, { payload, type }) => {
  switch (type) {
    case PENDIENTE_LOADING:
      return {
        ...state,
        pendiente: {
          ...state.pendiente,
          error: false,
          loading: true,
        },
      };

    case PENDIENTE_SUCCESS:
      return {
        ...state,
        pendiente: {
          ...state.pendiente,
          loading: false,
          error: false,
          data: payload,
        },
      };

    case PENDIENTE_ERROR:
      return {
        ...state,
        pendiente: {
          ...state.pendiente,
          error: payload,
          loading: false,
        },
      };

    case POST_PENDIENTE_LOADING:
      return {
        ...state,
        pendientePost: {
          ...state.pendientePost,
          error: false,
          loading: true,
        },
      };

    case POST_PENDIENTE_SUCCESS:
      return {
        ...state,
        pendientePost: {
          ...state.pendientePost,
          loading: false,
          error: false,
          data: payload,
        },
      };

    case POST_PENDIENTE_ERROR:
      return {
        ...state,
        pendientePost: {
          ...state.pendientePost,
          error: payload,
          loading: false,
        },
      };

    case CLEAR_PENDIENTE_DATA:
      return {
        ...state,
        pendiente: pendienteInitialState,
      };

    default:
      return state;
  }
};

export default pendiente;
